import * as studentActions from '../actions/students-actions/students-postsecondary-actions';
import { MergeUtilities } from '../utilities';
export interface IStudentState {
  loading: boolean;
  loaded: boolean;
  studentEntities: object;
  loadedProjection: object;
  sort: object;
  dimensions: object;
}

export const initialState: IStudentState = {
  loading: false,
  loaded: false,
  studentEntities: {},
  loadedProjection: {},
  sort: {},
  dimensions: {},
};
export function reducer(
  state: IStudentState = initialState,
  action: studentActions.PostsecondaryActions,
): IStudentState {
  switch (action.type) {
    case studentActions.LOAD_POSTSECONDARY_STUDENTS: {
      return { ...state, loading: true };
    }

    case studentActions.LOAD_POSTSECONDARY_STUDENTS_SUCCESS: {
      const studentList = action.payload;
      const studentEntities = studentList.reduce((acc, student) => {
        acc[student._id] = student;
        return acc;
      }, {});
      return {
        ...state,
        loading: false,
        loaded: true,
        studentEntities,
      };
    }

    case studentActions.LOAD_POSTSECONDARY_STUDENTS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case studentActions.BULK_UPDATE_POSTSECONDARY_STUDENTS: {
      return { ...state, loading: true };
    }

    case studentActions.BULK_UPDATE_POSTSECONDARY_STUDENTS_SUCCESS: {
      const { patches } = action.payload;
      const studentEntities = patches.reduce(
        (studentEntities, { _ids, patch }) => {
          _ids.forEach(_id => {
            if (studentEntities[_id]) {
              studentEntities[_id] = MergeUtilities.deepMergeObjs(studentEntities[_id], patch);
            }
          });
          return studentEntities;
        },
        { ...state.studentEntities },
      );
      return { ...state, studentEntities };
    }

    case studentActions.BULK_UPDATE_POSTSECONDARY_STUDENTS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    default:
      return state;
  }
}
